import decoder from './decoder'

export default decoder



// WEBPACK FOOTER //
// ./src/lib.js